const config = {
  api: {
    portalLocal: 'http://10.0.0.97:3300',
    customer: 'https://th-customer-api.dimorder.com',
    dimorder: 'https://th-api.dimorder.com',
    node: 'https://th-node.dimorder.com',
  },
  env: 'prod',
  keetaAppId: '3483789837',
  receipt: 'https://th-mp-order.dimorder.com/',
  report: 'https://th-report-api.dimorder.com/report/',
}

export default config
